<template>
    <ul class="list-reset flex justify-center select-none -mx-2">
        <li>
            <span v-if="page === 1" class="text-white px-2">&lt;</span>
            <a v-else @click.prevent="onChangePage(prev)" class="cursor-pointer px-2">&lt;</a>
        </li>
        <li v-if="page > 6">
            <a @click.prevent="onChangePage(1)" class="cursor-pointer px-2">{{ 1 }}</a>
            <span class="text-white px-2">&hellip;</span>
        </li>
        <li v-if="total" v-for="value in pages" :class="{'active': value == page}">
            <span v-if="value == page" class="text-white px-2">{{page}}</span>
            <a v-else @click.prevent="onChangePage(value)" class="cursor-pointer px-2">{{ value }}</a>
        </li>
        <li v-if="page < total - 5">
            <span class="text-white px-2">&hellip;</span>
            <a @click.prevent="onChangePage(total)" class="cursor-pointer px-2">{{ total }}</a>
        </li>
        <li>
            <span v-if="page === total" class="text-white px-2">&gt;</span>
            <a v-else @click.prevent="onChangePage(next)" class="cursor-pointer px-2">&gt;</a>
        </li>
    </ul>
</template>

<script>
import { range } from "lodash";

export default {
    props: {
        page: {
            type: Number,
            default: 1,
        },
        total: {
            type: Number,
            default: null,
        }
    },

    computed: {
        prev() {
            return this.page - 1
        },

        next() {
            return this.page + 1
        },

        pages() {
            let first = this.page - 5
            let last = this.page + 5

            if (first <= 0) {
                first = 1
            }

            if (last >= this.total) {
                last = this.total + 1
            }

            return range(first, last)
        },
    },

    methods: {
        onChangePage(page) {
            this.$emit('change', page)
        }
    }
}
</script>

<style>

</style>
